module.exports = {
    CREATE_EQUIPMENT: "CREATE_EQUIPMENT",
    CREATE_EQUIPMENT_REQUEST: "CREATE_EQUIPMENT_REQUEST",
    CREATE_EQUIPMENT_FAIL: "CREATE_EQUIPMENT_FAIL",

    SUBMIT_EQUIPMENT: "SUBMIT_EQUIPMENT",
    SUBMIT_EQUIPMENT_REQUEST: "SUBMIT_EQUIPMENT_REQUEST",
    SUBMIT_EQUIPMENT_FAIL: "SUBMIT_EQUIPMENT_FAIL",

    UPDATE_EQUIPMENT: "UPDATE_EQUIPMENT",
    UPDATE_EQUIPMENT_REQUEST: "UPDATE_EQUIPMENT_REQUEST",
    UPDATE_EQUIPMENT_FAIL: "UPDATE_EQUIPMENT_FAIL",

    SET_EQUIPMENT_DRAFT: "SET_EQUIPMENT_DRAFT",
    SET_EQUIPMENT_DRAFT_REQUEST: "SET_EQUIPMENT_DRAFT_REQUEST",
    SET_EQUIPMENT_DRAFT_FAIL: "SET_EQUIPMENT_DRAFT_FAIL",

    SET_EQUIPMENT_SERVICED: "SET_EQUIPMENT_SERVICED",
    SET_EQUIPMENT_SERVICED_REQUEST: "SET_EQUIPMENT_SERVICED_REQUEST",
    SET_EQUIPMENT_SERVICED_FAIL: "SET_EQUIPMENT_SERVICED_FAIL",

    GET_EQUIPMENTS: "GET_EQUIPMENTS",
    GET_EQUIPMENTS_REQUEST: "GET_EQUIPMENTS_REQUEST",
    GET_EQUIPMENTS_FAIL: "GET_EQUIPMENTS_FAIL",

    GET_EQUIPMENT: "GET_EQUIPMENT",
    GET_EQUIPMENT_REQUEST: "GET_EQUIPMENT_REQUEST",
    GET_EQUIPMENT_FAIL: "GET_EQUIPMENT_FAIL",

    GET_EQUIPMENTS_BY_USER: "GET_EQUIPMENTS_BY_USER",
    GET_EQUIPMENTS_BY_USER_REQUEST: "GET_EQUIPMENTS_BY_USER_REQUEST",
    GET_EQUIPMENTS_BY_USER_FAIL: "GET_EQUIPMENTS_BY_USER_FAIL",

    GET_EQUIPMENTS_BY_LOCATION: "GET_EQUIPMENTS_BY_LOCATION",
    GET_EQUIPMENTS_BY_LOCATION_REQUEST: "GET_EQUIPMENTS_BY_LOCATION_REQUEST",
    GET_EQUIPMENTS_BY_LOCATION_FAIL: "GET_EQUIPMENTS_BY_LOCATION_FAIL",

    DELETE_EQUIPMENT: "DELETE_EQUIPMENT",
    DELETE_EQUIPMENT_REQUEST: "DELETE_EQUIPMENT_REQUEST",
    DELETE_EQUIPMENT_FAIL: "DELETE_EQUIPMENT_FAIL",
}